// extracted by mini-css-extract-plugin
module.exports = {"dataBlock":"DataBlock_dataBlock__vU-7I","blockHeader":"DataBlock_blockHeader__Rth4b","dashboardCardList":"DataBlock_dashboardCardList__3vUck"};